import React from "react";
const ComparativeLoading = () => {
  return <div> ComparativeLoading</div>;
};
export default ComparativeLoading;
